// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3IbY7","requiredAsterisk":"Info_requiredAsterisk__1fXY9"};